import React from 'react';
import { CardLinkAsset, ConciergeTileAsset, PropAsset } from '../../usePropValues';
import { CardTileConcierge } from './components/CardTileConcierge';
import { CardLink } from './components/CardLink';
import { CardTile, CardTileSource } from './components/CardTile';
import { ValuePropCard } from './components/ValueProps/ValuePropCard';
import { isConciergeServiceCategory } from '@apps/card/routes/Concierge/config';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { CardCarouselSlide } from './hooks/useCardCarouselValues';
import { CardFormat } from '../../../ProductDetailsPage/constants';
import { StationeryTemplate } from '../../DesignsGallery.types';

export type ConciergeSelectedEvent = {
  id: string;
};

export type CardEventType = ConciergeSelectedEvent & { type: 'conciergeselectedevent' };

export type GalleryItemData =
  | (PropAsset & { type: 'prop' })
  | (StationeryTemplate & { type: 'template' })
  | (CardLinkAsset & { type: 'cardlink' })
  | (ConciergeTileAsset & { type: 'concierge' });

type GalleryItemProps = {
  preferredFormat?: CardFormat;
  eventId?: string;
  data: GalleryItemData;
  eventDesignThemeId?: string;
  onCardSelect: (event: CardEventType) => void;
  hideCardTileTag?: boolean;
  cardTileSource: CardTileSource;
  tagCount?: number;
  showSearchDebugInfo?: boolean;
  disableAssetRotationOnHover: boolean;
  cardCarouselSlides?: CardCarouselSlide[];
  enableFreePriceString?: boolean;
  currentCategory: StationeryTemplateCategoryEnum;
};

export const GalleryItem = (props: GalleryItemProps) => {
  const {
    data,
    preferredFormat,
    disableAssetRotationOnHover,
    cardCarouselSlides,
    cardTileSource,
    eventDesignThemeId,
    onCardSelect,
    eventId,
    hideCardTileTag,
    tagCount,
    showSearchDebugInfo,
    enableFreePriceString,
    currentCategory,
  } = props;
  switch (data.type) {
    case 'prop':
      return <ValuePropCard data={data} />;
    case 'cardlink':
      return <CardLink data={data} />;
    case 'template':
      return (
        <CardTile
          showSearchDebugInfo={showSearchDebugInfo}
          tagCount={tagCount}
          disableAssetRotationOnHover={disableAssetRotationOnHover}
          cardTileSource={cardTileSource}
          data={data}
          hideTag={hideCardTileTag}
          eventDesignThemeId={eventDesignThemeId}
          eventId={eventId}
          cardCarouselSlides={cardCarouselSlides}
          enableFreePriceString={enableFreePriceString}
          preferredFormat={preferredFormat}
        />
      );
    case 'concierge':
      if (isConciergeServiceCategory(currentCategory)) {
        return (
          <CardTileConcierge
            category={currentCategory}
            data={data}
            onSelect={onCardSelect}
          />
        );
      }
      return null;
  }
};
